export function numberWithCommas(value) {
  const stringValue = value.toString();
  const pattern = /(-?\d+)(\d{3})/;
  let result = stringValue;

  while (pattern.test(result)) {
    result = result.replace(pattern, '$1,$2');
  }

  return result;
}

export function valueLabelFormat(value) {
  const units = ['K', 'M'];
  let scaledValue = value;

  if (scaledValue <= 1000000) {
    return '< $1M';
  }

  if (scaledValue >= 25000000) {
    return '$25M+';
  }

  let unitIndex = 0;
  while (scaledValue >= 1000000 && unitIndex < units.length - 1) {
    unitIndex += 1;
    scaledValue /= 1000000;
  }

  return `$${scaledValue}${units[unitIndex]}`;
}
